const API_PATHS = {
  config: '/jxsj/groupbuying260902/get_config',
  gifts: '/jxsj/groupbuying260902/gift_list',
  phone: '/jxsj/groupbuying260902/get_phone',
  phoneCode: '/jxsj/groupbuying260902/get_phone_code',
  activate: '/jxsj/groupbuying260902/activate',
  team: '/jxsj/groupbuying260902/team_config',
  order: '/jxsj/groupbuying260902/create_order',
  accountList: '/jxsj/groupbuying260902/show_account_list'
};

export const mockScenarios = {
  unreserved: {
    [API_PATHS.config]: 'unreserved',
    [API_PATHS.gifts]: 'available',
    [API_PATHS.accountList]: 'with_data'
  },
  reserved: {
    [API_PATHS.config]: 'reserved',
    [API_PATHS.gifts]: 'available'
  },
  phoneUnbound: {
    [API_PATHS.config]: 'unreserved',
    [API_PATHS.phone]: 'unbound'
  },
  reservationWithFriends: {
    [API_PATHS.config]: 'unreserved',
    [API_PATHS.phone]: 'bound',
    [API_PATHS.phoneCode]: 'success',
    [API_PATHS.activate]: 'success_with_friends'
  },
  reservationWithoutFriends: {
    [API_PATHS.config]: 'unreserved',
    [API_PATHS.phone]: 'bound',
    [API_PATHS.phoneCode]: 'success',
    [API_PATHS.activate]: 'success_without_friends'
  },
  normalGiftPurchased: {
    [API_PATHS.config]: 'reserved',
    [API_PATHS.gifts]: 'normal_gift_purchased'
  },
  thunderGiftsPurchased: {
    [API_PATHS.config]: 'unreserved',
    [API_PATHS.gifts]: 'thunder_gifts_purchased',
    [API_PATHS.accountList]: 'with_data'
  },
  createTeam: { [API_PATHS.team]: 'create_team' },
  joinTeam: { [API_PATHS.team]: 'join_team' },
  inviteFriend: {
    [API_PATHS.config]: 'reserved',
    [API_PATHS.gifts]: 'invite_friend',
    [API_PATHS.accountList]: 'with_data',
    [API_PATHS.team]: 'invite_friend'
  },
  teamSuccess: { [API_PATHS.team]: 'team_success' },
  guestTeamSuccess: {
    [API_PATHS.config]: 'reserved',
    [API_PATHS.gifts]: 'available',
    [API_PATHS.accountList]: 'empty',
    [API_PATHS.team]: 'team_success'
  },
  teamFull: { [API_PATHS.team]: 'team_full' },
  teamUnavailable: { [API_PATHS.team]: 'team_unavailable' },
  apiError: {
    [API_PATHS.config]: 'api_error',
    [API_PATHS.gifts]: 'api_error',
    [API_PATHS.phone]: 'api_error',
    [API_PATHS.phoneCode]: 'api_error',
    [API_PATHS.activate]: 'api_error',
    [API_PATHS.team]: 'api_error',
    [API_PATHS.order]: 'api_error',
    [API_PATHS.accountList]: 'api_error'
  }
};

export const applyMockScenario = scenarioName => {
  const scenario = mockScenarios[scenarioName];
  if (!scenario) {
    throw new Error(`Unknown ZT mock scenario: ${scenarioName}`);
  }
  window.MOCK_SCENARIO_MAP = { ...scenario };
  window.__mockScenarioMap = window.MOCK_SCENARIO_MAP;
  return window.MOCK_SCENARIO_MAP;
};

export const applyMockScenarioFromSearch = (search = window.location.search) => {
  const scenarioName = new URLSearchParams(search).get('mock_scenario');
  return scenarioName ? applyMockScenario(scenarioName) : null;
};

export default mockScenarios;
